<template>
    <div class="widget-loading">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
             preserveAspectRatio="xMidYMid" class="trobber" style="background: none;">
            <path fill="none"
                  d="M24.3,30C11.4,30,5,43.3,5,50s6.4,20,19.3,20c19.3,0,32.1-40,51.4-40 C88.6,30,95,43.3,95,50s-6.4,20-19.3,20C56.4,70,43.6,30,24.3,30z"
                  :stroke="defaultColor" stroke-width="2" stroke-dasharray="243.75948181152344 12.829446411132807">
                <animate attributeName="stroke-dashoffset" calcMode="linear" values="0;256.58892822265625"
                         keyTimes="0;1" dur="1.6" begin="0s" repeatCount="indefinite">
                </animate>
            </path>
        </svg>
    </div>
</template>

<script>
  export default {
    name: 'widget-loading',
    props: {
      color: {
        required: false,
        type: String,
      }
    },
    data() {
      return {
        defaultColor: '#3490dc',
      }
    },
    mounted() {
      if (this.color) {
        this.defaultColor = this.color;
      }
    }
  };
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/elements/WidgetLoading.vue